/* import __COLOCATED_TEMPLATE__ from './introduction.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './introduction.module.scss';

@classic
@classNames(styles.component)
export default class SiteDocumentsGoodFaithEstimateIntroduction extends Component {}
